module.exports = __webpack_public_path__ + "05_face.57b98ca5.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/papa/layer1/05_face.png
// module id = A++e
// module chunks = 0